import React, { Dispatch, SetStateAction, useRef } from 'react';
import styles from "./downloadUploadExcel.module.scss";
import Button from "../../../../components/button/Button";
import Excel from "../../../../assets/icons/microsoft-excel.svg?react";
import { CellValue, Workbook } from 'exceljs';
import {cleanRichText, isRichText} from "../../../../utils/helpers";
import { logger } from '../../../../utils/logger';

let blob;

let generateExcel = () => {
  let workbook = new Workbook();
  let worksheet = workbook.addWorksheet('OP Bulk Upload');

  const header = ["First Name", "Last Name", "Email"];
  worksheet.mergeCells('A1:C1');
  worksheet.mergeCells('A2:C2');
  let row1 = worksheet.getCell("A1");
  row1.value = "Open Parachute Bulk User Uploader";
  row1.font = {
    size: 20
  }

  let row2 = worksheet.getCell("A2");
  row2.value = "Please fill in First Name, Surname and Email address of all teachers you wish to invite Note: All fields required.";

  let headerRow = worksheet.addRow(header);

  headerRow.eachCell((cell, number) => {
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: {argb: 'FFB073'},
      bgColor: {argb: 'FFB073'}
    }
    cell.border = {top: {style: 'thin'}, left: {style: 'thin'}, bottom: {style: 'thin'}, right: {style: 'thin'}}
  })

  for (let i = 1; i <= 3; i++) worksheet.getColumn(i).width = 40;

  // Generate Excel File with given name
  workbook.xlsx.writeBuffer().then((data) => {
    let link = document.createElement('a');
    link.download = 'OP-Bulk-User-Uploader.xlsx';
    blob = new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});

    link.href = URL.createObjectURL(blob);
    link.click();
  })
}

type Props = {
  setJsonParse: Dispatch<SetStateAction<any[]>>;
  accountOptions: any;
  schools: any;
};

export function DownloadUploadExcel(props: Props) {

  const fileUploader = useRef(null);
  const {setJsonParse} = props;

  const handleInputChange = (e: any) => {
    if (e.target.files.length > 0) {
      let f = e.target.files[0];
      const reader = new FileReader();
      reader.onload = async (evt) => { // evt = on_file_select event
        /* Parse data */
        if (evt && evt.target) {
          // ------------------------
          const buffer = reader.result;
          const wbe = new Workbook();
          await wbe.xlsx.load(buffer as ArrayBuffer).then((workbook) => {

            let updatedDataOne: any[] = [];
            let updatedDataIndexOne = 0;

            try {
              workbook.eachSheet((sheet, id) => {
                if (sheet?.name === "OP Bulk Upload") sheet.eachRow((row, rowIndex) => {

                  let valv: CellValue[] | { [p: string | number]: CellValue } | any[] = row.values;

                  if (rowIndex > 3 && (valv[1] || valv[2] || valv[3])) {

                    if (isRichText(valv[1])) valv[1] = cleanRichText(valv[1]);

                    if (isRichText(valv[2])) valv[2] = cleanRichText(valv[2]);

                    if (isRichText(valv[3])) valv[3] = cleanRichText(valv[3]);

                    let rowData = {
                      firstName: valv[1] || "",
                      lastName: valv[2] || "",
                      id: updatedDataIndexOne,
                      email: (typeof valv[3] === "string" && valv[3].trim().length > 0) ? valv[3].trim() : valv[3]?.text ? valv[3].text.trim() : "",
                      invite: "Yes",
                    }
                    updatedDataIndexOne++;
                    updatedDataOne.push(rowData);
                  }
                })
                setJsonParse(updatedDataOne)
              })
            } catch (e) {
              logger.info(e)
            }

          })
        }

      };
      reader.readAsBinaryString(f);
    }
  }

  return (
    <>
      <div style={{display: "flex", height: "100%"}}>
        <div style={{flex: 1}}>
          <h3 style={{marginTop: 0}}>Step 1: Generate and Download Your Template</h3>
          <div style={{marginBottom: 20, marginTop: 20}}>Download our Excel Bulk Upload template file:{" "}
            <a
              title={"Download"}
              style={{color: "#FFB073", cursor: "pointer"}}
              href='/'
              onClick={(e) => {
                e.preventDefault();
                generateExcel();
              }}
              download
            >Click to download</a>
          </div>
        </div>
        <div style={{
          width: "1px",
          borderRight: "solid 1px rgba(0, 0, 0, 0.2)",
          marginRight: "50px",
          marginLeft: "50px"
        }}/>
        <div style={{flex: 1}}>
          <h3 style={{marginTop: 0}}>Step 2: Upload Completed Excel Document</h3>
          <div className={styles.parentRow}>
            <div className={styles.uploader}>
              <input ref={fileUploader} onChange={(e) => handleInputChange(e)} type="file"
                     className={styles.fileInput}
                     accept=".csv, .xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"/>
              <Button label={'Upload Excel File'} color={'orange'} outline={true}
                      className={styles.inputButton}
                      leftIcon={<Excel/>}/>
            </div>
          </div>
        </div>
      </div>


    </>
  );
}
